/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react';
import { withTranslation } from 'react-i18next';

import { useForm, Controller } from 'react-hook-form';

import PersonAddIcon from '@material-ui/icons/PersonAdd';
import TextField from '@material-ui/core/TextField';

import { Grid, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Snackbar from '@material-ui/core/Snackbar';
import { useMutation } from '@apollo/client';
import { MATCH_TICKET_TO_ACCOUNT } from '../../queries';

import { yupResolver } from '@hookform/resolvers/yup'
import { TicketRegistrationSchema } from '../../validations/UserValidation'
import { formContent } from '../../statics/RegisterTicketFormData'
import GeneralButton from "../Buttons";
import GeneralText from "../Fonts";
import { useThemeData } from '../../context/ThemeDataContext';
import {useAuthData} from '../../context/AuthProvider';
import { usePhotoBaseData } from '../../context/PhotoBasicDataContext';

function RegistrateTicketFormComponent(props) {
  const [alertStatus, setAlertStatus] = React.useState({
    error: {
      open: false,
      message: undefined
    },
    horizontal: 'center',
    vertical: 'center'
  })
  const {vertical, horizontal} = alertStatus;
  const login_email =
    localStorage.hasOwnProperty("login_email") === true
      ? localStorage.getItem("login_email")
      : null;
  let logins = localStorage.getItem("login_name");
  const firstPartLogin = logins !== null ? logins.replace('["', '') : '';
  const MiddelPartLogin = firstPartLogin.replace('","', ', ');
  const login_name = MiddelPartLogin.replace('"]', '');

  const {setLoginName, loginName, setLogins} = useAuthData();
  const {refetchPhotos} = usePhotoBaseData();
  const site_id = useThemeData().themeData.site.site_id;
  const { primary_color_2  } = useThemeData().themeData.site.theme
  const { control, handleSubmit, formState:{ errors } } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onBlur',
    resolver: yupResolver(TicketRegistrationSchema)
  });

 function waitForCondition(list_of_logins) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
      if (loginName === localStorage.getItem('login_name') || list_of_logins === logins) {
        resolve();
      } else {
        reject('Error: ververs het scherm om de nieuwe fotos te zien!')
      }
      }, 2000);
    })
  }

  async function setLogin(data){
    let login_names = new Set();
    login_names.add(login_name);
    login_names.add(data.registerTicketToAccount.login_name[0]);
    let list_of_logins = Array.from(login_names);
    localStorage.setItem('login_name', JSON.stringify(list_of_logins));
    setLoginName(localStorage.getItem('login_name'));
    const firstPartLogin = JSON.stringify(list_of_logins) !== null ? JSON.stringify(list_of_logins).replace('["', '') : ''
    const MiddelPartLogin = firstPartLogin.replace('","', ', ')
    const login_name_string = MiddelPartLogin.replace('"]', '')
    const newLogin = {login_name: login_name_string}
    setLogins(newLogin);
    return await waitForCondition(newLogin);
}

const onCompleted = (data) => {
  const loginIsSet = setLogin(data);
  if (loginIsSet) {
      refetchPhotos();
  }
    // send toaster message to display on homepage and go to homepage
    const location = {
      pathname: "/",
      state: { alertStatus: {...alertStatus, success: {message: props.t('register:Succesmessage LoginTicket'), open: true} }}
    };
    props.history.push(location);
}

  const [registerTicketToAccount,
    { loading: loadingTicketToAccount, error: errorTicketToAccount }]
    = useMutation(MATCH_TICKET_TO_ACCOUNT, {
      onCompleted: (data) => onCompleted(data),
      onError: (error) => setAlertStatus(prevState => ({ ...prevState, success: {message: error.message, open: true} })),
    })

  const onSubmit = (e) => {
    registerTicketToAccount({
      variables: {
        input: {
          email: login_email,
          login_name: e.login_name,
          password: e.password,
          client_id: 2,
          client_secret: "B4qLlm3bRViBRU6D0DNyxn0V9XtXzeLJV7iUHErt",
          site_id: site_id
        }
      }
    })
  }
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertStatus(prevState => ({...prevState, error: {open: false, message: ''}}));
  };
  const onError = (errors, e) => console.log(errors, e);

  if (loadingTicketToAccount) return <p>{props.t('Loading...')}</p>

  return (
    <form onSubmit={handleSubmit(onSubmit, onError)}>
      <Snackbar anchorOrigin={{ vertical, horizontal }} name='error' open={alertStatus.error.open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error">
            {alertStatus.error.message}
          </Alert>
        </Snackbar>

      <Grid container direction="row">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Grid container direction="row">
            <GeneralText
                style={{color: primary_color_2}}
              variant="h6"
              gutterBottom={true}
            >
              {props.t('register:LoginTickets')}
            </GeneralText>
              <Typography>
                {props.t('register:LoginTickets text')}
              </Typography>
          </Grid>
        </Grid>
      </Grid>
      {errorTicketToAccount &&
      <Alert severity="error">
        <strong>{props.t('register:AlreadyExists')}</strong>
      </Alert>
      }
      {formContent.inputs.map((input, key) => (
      <Grid container direction="row" key={key}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Controller name={input.name} control={control} render={({field}) => 
          <TextField
            {...field}
            id={input.id}
            type={input.type}
            margin="normal"
            label={props.t(`register:${input.label}`)}
            autoComplete={input.autocomplete}
            className="mb-2"
            variant="outlined"
            autoFocus
            fullWidth
          />
        }/>

          {errors[input.name] &&
          <Alert severity="warning">
            {props.t(`register:${errors[input.name].message}`)}
          </Alert>
          }

        </Grid>
      </Grid>
      ))}

      <Grid container direction="row">
          <GeneralButton
            type="submit"
            className="nav-button"
            style={{width: '-webkit-fill-available'}}
            endIcon={<PersonAddIcon color="inherit" />}
          >
            {props.t('register:Add to Account')}
          </GeneralButton>
        </Grid>
    </form>
  )
}

export default React.memo(withTranslation(['message', 'register'])(RegistrateTicketFormComponent));
